import {copy} from '../../../../../../../util/fieldscopy'
import {FormSectionType} from '../../../../../../blocks/FormBlock'
import confirmEMail from '../../fields/confirmEMail'
import eMail from '../../fields/eMail'
import fName from '../../fields/fName'
import lName from '../../fields/lName'
import optin from '../../fields/optin'
import phone from '../../fields/phone'

const personalData: FormSectionType = {
	id: 1,
	parent_id: 2,
	channel: 'section',
	label: copy?.person_details || 'Persoonsgegevens',
	fields: [fName, lName, eMail, confirmEMail, optin, phone].map((field) => {
		return {...field, parent_id: 1}
	})
}

export default personalData
